/**
 * Fills {name} placeholders in a Payload text. Payload texts must not go through vue-i18n's t(),
 * which would interpret the placeholders itself. Unknown placeholders stay visible.
 */
export function fillPlaceholders(text: string, values: Record<string, string>): string {
  return text.replace(/\{(\w+)\}/g, (match, name: string) => values[name] ?? match)
}
